import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import PermissionManage from "../permissionManage";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ userIds, type, successCb }) => {
  const [visible, setVisible] = useState(false);
  const [roleIds, setRoleIds] = useState([]);

  return (
    <>
      {type === "batch" && (
        <Button
          onClick={() => {
            if (!userIds?.length) {
              message.warning("请先选择角色！");
              return;
            }
            setVisible(true);
          }}
          style={{ marginLeft: 16 }}
        >
          批量关联权限
        </Button>
      )}
      {type !== "batch" && <a onClick={() => setVisible(true)}>关联权限</a>}
      <Modal
        width={1000}
        open={visible}
        onCancel={() => setVisible(false)}
        title="关联权限"
        onOk={() => {
          if (!roleIds?.length) {
            message.warning("请先选择权限！");
            return;
          }
          const url =
            type === "batch"
              ? `${localhost}/manage/user/batchLinkRole`
              : `${localhost}/manage/user/linkRole`;
          axios
            .post(url, {
              roleIdList: [],
              userIdList: type === "batch" && userIds,
              userId: type !== "batch" && userIds,
            })
            .then((res) => {
              message.success("删除成功！");
              successCb();
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      >
        <PermissionManage
          pageMode="connent"
          updateSelectedRowKeys={(keys) => setRoleIds(keys)}
        />
      </Modal>
    </>
  );
};
